module.exports = __webpack_public_path__ + "media/tarifwechsel.a82117d1.mp4";